import useAutomationValues from './useAutomationValues';

export function useWorkflow(conditionsSource) {
  const {
    getConditionDropdownValues,
    agents,
    campaigns,
    contacts,
    inboxes,
    labels,
    teams,
    slaPolicies,
    booleanFilterOptions,
    statusFilterOptions,
  } = useAutomationValues();

  // normaliza: aceita ref OU array
  const getConditions = () => {
    if (!conditionsSource) return [];
    if (Array.isArray(conditionsSource)) return conditionsSource;
    return conditionsSource.value || [];
  };

  const appendNewCondition = () => {
    const conditions = getConditions();

    conditions.push({
      attribute_key: '',
      filter_operator: '',
      values: [],
    });
  };

  const removeFilter = index => {
    const conditions = getConditions();

    if (conditions.length <= 1) return;
    conditions.splice(index, 1);
  };

  return {
    getConditionDropdownValues,
    appendNewCondition,
    removeFilter,
    agents,
    campaigns,
    contacts,
    inboxes,
    labels,
    teams,
    slaPolicies,
    booleanFilterOptions,
    statusFilterOptions,
  };
}
